import {
  AkinatorCompletion,
  CategorySuggestion,
  NewSuggestion,
  SlicedSuggestions,
  Suggestion,
  Suggestions,
} from 'types/suggestions';

type PreparedSuggestions = {
  slicedSuggestions: SlicedSuggestions | null;
  flatSuggestions: Suggestion[] | null;
  akinatorCompletions: AkinatorCompletion[] | null;
};

export const prepareSuggestions = (suggestions: Suggestions | null, value: string): PreparedSuggestions => {
  if (!suggestions) {
    return {
      slicedSuggestions: null,
      flatSuggestions: null,
      akinatorCompletions: null,
    };
  }

  const isDefaultList = !value;
  const slicedSuggestions = isDefaultList
    ? getDefaultListSuggestions(suggestions.newSuggestions, suggestions.categories)
    : getSearchSuggestions(suggestions.newSuggestions, value);

  return {
    slicedSuggestions,
    flatSuggestions: [...slicedSuggestions[0], ...slicedSuggestions[1]],
    akinatorCompletions: isDefaultList ? [] : suggestions.completions,
  };
};

function getDefaultListSuggestions(
  newSuggestions: NewSuggestion[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  if (categories.length > 0) {
    return [[], categories];
  }

  return [newSuggestions, []];
}

function getSearchSuggestions(newSuggestions: NewSuggestion[], value: string): SlicedSuggestions {
  if (newSuggestions.length > 0) {
    return [newSuggestions, []];
  }

  const emptySuggestion: NewSuggestion = {
    name: value,
    pageId: null,
    pageUrl: null,
    type: 'SRP',
    familyId: null,
    imageUrl: null,
    labels: [],
    fillingOrder: 0,
  };

  return [[emptySuggestion], []];
}
